export default "__VITE_ASSET__DttZbW5W__"